var filteredLists = [];

$(document).ready(function () {

    $(document).on('click', ".ctaButton", function () {
        if (typeof SitecorectaForm != 'undefined' && SitecorectaForm.formValidation() != null) {
            $('#' + SitecorectaForm.formValidation().FormId).formValidation('validate');
        }
        var input = $('.ctaInput').val();
        if (input != null && input.length > 0) {
            var btn = $(this);
            var link = btn.attr('data-link');
            if (link != null) {
                window.location.href = link + '?countryCode=AU&postalCode=' + input + '&resultType=Dealer';
            }
        } else {
            $('.ctaInputError').val('Postal Code is required.');
        }
    });

    $('#customerClaim').on('keyup keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

    // Custom control features
    var filteringControls = $(".filteredLinkType");
    if (filteringControls.length > 0) {
        filteringControls.each(function (index) {
            var ddl = $(this);
            var control = ddl.attr("data-control-link");
            filteredLists.push({
                filteredList: ddl.prop('id'),
                filteredControl: control,
                filteredListItems: $('#' + control + ' option')
            });
        });
    }

    $(document).on("change", ".filteredLinkType", function () {
        var ddl = $(this);
        var filteredControl = $.grep(filteredLists, function (item) {
            return item.filteredList == ddl.prop('id');
        });
        var control = ddl.attr("data-control-link");
        var value = $('option:selected', ddl).attr("data-filter-value");
        if (control !== null && value !== null) {
            $("#" + control + " option").remove();
            $('#' + control).append(filteredControl[0].filteredListItems);
            $("#" + control + " option").not('[data-filter-value="' + value + '"]').not('[data-filter-value=""]').remove();
            $("#" + control + " option[data-filter-value='']").prop('selected', true);
        }
    });

    $("#clearFile").on("click", function () {
        var ctrl = $('#fileupload');
        $('#' + SitecoreForm.formValidation().FormId).formValidation('revalidateField', ctrl.attr('name'));
    });

    $.fn.hideOption = function () {
        var text = $(this).text(),
            val = this.value,
            span =
                $('<span/>').text(text).val(val).hide();

        var old = $(this).clone();
        $(this).replaceWith(span);
        $(span).data('ref', old);
    };

    $.fn.showOption = function () {
        if ($(this).data('ref'))
            $(this).replaceWith($(this).data('ref'));
    };

    $(document).on("change", ".hiddenLinkType", function () {
        var ctrl = $(this);
        var type = ctrl.prop('tagName');
        var value = $('option:selected', ctrl).length > 0 ? $('option:selected', ctrl).attr("value") : ctrl.attr("checked");
        if (type == 'SELECT') {
            if (ctrl.attr('data-filter-value') == null || ctrl.attr('data-filter-value') == '') {
                hideShowControls(ctrl, value == "yes" || value == "Yes" || value == "true" || value == "True" || value == true);
            }
        } else if (type == 'INPUT' && ctrl.attr('type') == 'checkbox') {
            value = this.checked;
            hideShowControls(ctrl, value == "true" || value == "True" || value == true);
        } else if (type == 'INPUT' && ctrl.attr('type') == 'radio') {
            value = this.checked;
            hideShowControls(ctrl, value == "true" || value == "True" || value == true);
        }
    });

    $(".hiddenLinkType").each(function () {
        hideShowControls($(this), false);
    });

    $(document).on("change", ".hideLinkType", function () {
        var ctrl = $(this);
        var type = ctrl.prop('tagName');
        var filterValue = ctrl.attr('data-filter-value');
        var value = $('option:selected', ctrl).length > 0 ? $('option:selected', ctrl).attr("value") : ctrl.attr("checked");
        if (type == 'SELECT') {
            hideShowControls(ctrl, value == "yes" || value == "Yes" || value == "true" || value == "True" || value == true);
        } else if (type == 'INPUT' && ctrl.attr('type') == 'checkbox') {
            value = this.checked;
            hideShowControls(ctrl, !(value == "true" || value == "True" || value == true));
        } else if (type == 'INPUT' && ctrl.attr('type') == 'radio') {
            $(".hideLinkType").each(function () {
                hideShowControls($(this), true);
            });
            value = this.checked;
            hideShowControls(ctrl, !(value == "true" || value == "True" || value == true));
        }
    });

    $(".hideLinkType").each(function () {
        hideShowControls($(this), true);
    });

    $(document).on("change", ".showLinkType", function () {
        var ctrl = $(this);
        var type = ctrl.prop('tagName');
        var filterValue = ctrl.attr('data-filter-value');
        var value = $('option:selected', ctrl).length > 0 ? $('option:selected', ctrl).attr("value") : ctrl.attr("checked");
        if (type == 'SELECT') {
            hideShowControls(ctrl, value == "yes" || value == "Yes" || value == "true" || value == "True" || value == true);
        } else if (type == 'INPUT' && ctrl.attr('type') == 'checkbox') {
            value = this.checked;
            hideShowControls(ctrl, value == "true" || value == "True" || value == true);
        } else if (type == 'INPUT' && ctrl.attr('type') == 'radio') {
            $(".showLinkType").each(function () {
                hideShowControls($(this), false);
            });
            value = this.checked;
            hideShowControls(ctrl, value == "true" || value == "True" || value == true);
        }
    });

    $(".showLinkType").each(function () {
        hideShowControls($(this), false);
    });

    $(document).on('input', '[data-fv-notempty="true"]', function () {
        var ctrl = $(this);
        var value = ctrl.val();
        if (value == '') {
            $('#' + SitecoreForm.formValidation().FormId).formValidation('revalidateField', ctrl.attr('name'));
        }
    });

    $(document).on('change', '.lookupHiddenLinkType', function () {
        var ctrl = $(this);
        var value = ctrl.val().toLowerCase();
        if (value !== null && value !== '') {
            var lookupModel = JSON.parse(ctrl.attr('data-control-lookup-object').replace(/'/g, '"'));
            $.each(lookupModel.Objects, function (i, v) {
                //var models = v.Lookups//ctrl.attr('data-control-lookup');
                //if (models !== null && models !== '') {
                var modelArray = v.Lookups; //models.split(',');
                if (modelArray.length > 0) {
                    if (modelArray.indexOf(value) >= 0) {
                        if (v.Secondaries != null && v.Secondaries.length > 0) {
                            getSecondaryValue(value, v.Secondaries, ctrl.attr('name'));
                        } else {
                            $('#fileUploadValue').val('');
                            $('#fileUploadType').val('');
                            $('#fileUploadName').val('');
                        }
                        hideShowLookupHiddenControls(ctrl, v.Links, true);
                    } else {
                        $('#fileUploadValue').val('');
                        $('#fileUploadType').val('');
                        $('#fileUploadName').val('');
                        hideShowLookupHiddenControls(ctrl, v.Links, false);
                    }
                }
                //}
            });
        } else {
            var lookupModel = JSON.parse(ctrl.attr('data-control-lookup-object').replace(/'/g, '"'));
            $.each(lookupModel.Objects, function (i, v) {
                hideShowLookupHiddenControls(ctrl, v.Links, false);
            });
        }
    });

    $(document).on('change', '.multiLookupHiddenLinkType', function () {
        var ctrl = $(this);
        var value = ctrl.val().toLowerCase();
        if (value !== null && value !== '') {
            var lookupModel = JSON.parse(ctrl.attr('data-control-multilookup-object').replace(/'/g, '"'));
            $.each(lookupModel.Objects, function (i, v) {
                var found = false;
                $.each(v.Groups, function (gi, gv) {
                    var primary = gv.PrimaryValues;
                    var primaryControl = $('[name="' + gv.PrimaryControl + '"]');
                    var secondary = gv.SecondaryValues;
                    var secondaryControl = $('[name="' + gv.SecondaryControl + '"]');
                    if ((primaryControl != null && primaryControl.length > 0
                        && secondaryControl != null && secondaryControl.length > 0)
                        && (primary.length > 0 && secondary.length > 0)) {
                        if (primary.indexOf(primaryControl.val().toLowerCase()) >= 0 && secondary.indexOf(secondaryControl.val().toLowerCase()) >= 0) {
                            var primarySecondaries = gv.PrimarySecValues;
                            found = true;
                            if (gv.PrimarySecValues != null && gv.PrimarySecValues.length > 0) {
                                getSecondaryValue(primaryControl.val(), gv.PrimarySecValues, ctrl.attr('name'));
                            } else if (gv.SecondarySecValues != null && gv.SecondarySecValues.length > 0) {
                                getSecondaryValue(secondaryControl.val(), gv.SecondarySecValues, ctrl.attr('name'));
                            } else {
                                $('#fileUploadValue').val('');
                                $('#fileUploadType').val('');
                                $('#fileUploadName').val('');
                            }
                            hideShowLookupHiddenControls(ctrl, v.Links, true);
                            return;
                        }
                    }
                });
                if (!found) {
                    $('#fileUploadValue').val('');
                    $('#fileUploadType').val('');
                    $('#fileUploadName').val('');
                    $('#ModelNumberSecondary').val('');
                    hideShowLookupHiddenControls(ctrl, v.Links, false);
                }
            });
        } else {
            $('#ModelNumberSecondary').val('');
            var lookupModel = JSON.parse(ctrl.attr('data-control-multilookup-object').replace(/'/g, '"'));
            $.each(lookupModel.Objects, function (i, v) {
                hideShowLookupHiddenControls(ctrl, v.Links, false);
            });
        }
        if ($("#country").length > 0) {
            var ddl = $('#country');
            if ($('option:selected', ddl).val() != 'USA' && $('option:selected', ddl).val() != 'US' && $('option:selected', ddl).val() != 'CA') {
                $('#ignoreAddress').val("true");
                $('#ignoreChuteValidation').val("true");
                $('#form-group-requestsidedischargechute').hide();
                $('#form-group-freegiftsection').hide();
                $('#form-group-extendedwarranty').hide();
            }
        }
    });

    $(".lookupHiddenLinkType").each(function () {
        var ctrl = $(this);
        var lookupModel = JSON.parse(ctrl.attr('data-control-lookup-object').replace(/'/g, '"'));
        $.each(lookupModel.Objects, function (i, v) {
            hideShowLookupHiddenControls($(this), v.Links, false);
        });
    });

    $(".multiLookupHiddenLinkType").each(function () {
        var ctrl = $(this);
        var lookupModel = JSON.parse(ctrl.attr('data-control-multilookup-object').replace(/'/g, '"'));
        $.each(lookupModel.Objects, function (i, v) {
            hideShowLookupHiddenControls($(this), v.Links, false);
            var controls = [];
            $.each(v.Groups, function (gi, gv) {
                if (controls.indexOf(gv.PrimaryControl) < 0) {
                    controls.push(gv.PrimaryControl);
                }
                if (controls.indexOf(gv.SecondaryControl) < 0) {
                    controls.push(gv.SecondaryControl);
                }
            });
            if (controls.length > 0) {
                $.each(controls, function (ci, cv) {
                    var control = $('[name="' + cv + '"]');
                    if (control != null && control.length > 0) {
                        if (!control.hasClass('multiLookupHiddenLinkType')) {
                            control.addClass('multiLookupHiddenLinkType');
                            control.attr('data-control-multilookup-object', ctrl.attr('data-control-multilookup-object'));
                            control.attr('data-control-link-type', 'Multi Lookup Hidden Fields');
                        }
                    }
                })
            }
        });
    });

    function getSecondaryValue(value, values, id) {
        var secondValue = null;
        $.each(values, function (i, v) {
            var model = v.split('|')[0];
            if (model == value) {
                var second = v.split('|')[1];
                if (second != null && second != '') {
                    var secondCtrl = $('#ModelNumberSecondary');
                    secondValue = '';
                    if (secondCtrl != null && secondCtrl.length > 0) {
                        secondCtrl.val(second);
                        //return;
                    }
                }
            }
        });
    }

    // Hides or shows any controls linked to filter control
    function hideShowControls(ctrl, show) {
        var controlStr = ctrl.attr("data-control-link");
        if (controlStr !== null) {
            var controls = [];
            controls = controlStr.split(",");
            $.each(controls, function (i, v) {
                var control = $('#form-group-' + v);
                if (show) {
                    $('#form-group-' + v).show();
                } else {
                    if ($('#' + v).attr('type') == 'checkbox') {
                        $('#' + v).prop('checked', false);
                        //$('#' + v).val(false);
                    } else {
                        $('#' + v).val('');
                    }
                    $('#form-group-' + v).hide();
                }
                $('#form-group-' + v).find("*[data-control-link]").trigger('change');
                var select = control.find('select');
                if (select !== null && select.length !== 0) {
                    var selected = control.find('[data-selected="true"]');
                    select.val(selected.val());
                }
            });
        }
    }

    // Hides or shows any controls linked to filter control
    function hideShowLookupHiddenControls(ctrl, controls, show) {
        //var controlStr = ctrl.attr("data-control-link");
        if (controls !== null && controls.length > 0) {
            //var controls = [];
            //controls = controlStr.split(",");
            $.each(controls, function (i, v) {
                var control = $('#form-group-' + v);
                if (show) {
                    $('#form-group-' + v).show();
                } else {
                    if ($('#' + v).attr('type') == 'checkbox') {
                        $('#' + v).prop('checked', false);
                        //$('#' + v).val(false);
                    } else {
                        $('#' + v).val('');
                    }
                    $('#form-group-' + v).hide();
                }
                $('#form-group-' + v).find("*[data-control-link]").trigger('change');
                var select = control.find('select');
                if (select !== null && select.length !== 0) {
                    var selected = control.find('[data-selected="true"]');
                    select.val(selected.val());
                }
            });
        }
    }

    // Custom Validation methods   
    (function ($) {
        FormValidation.validators.pastdate = function() {
            return {
                validate: function (input) {
                    var value = input.value;
                    var options = input.options;
                    if (value == '') {
                        return {
                            valid: false
                        };
                    }
                    var dateStr = value.split("/");
                    var date = new Date();
                    if (options.format.toLowerCase() == 'mm/dd/yyyy') {
                        date = new Date(dateStr[2], dateStr[0] - 1, dateStr[1]);
                    } else if (options.format.toLowerCase() == 'yyyy/mm/dd') {
                        date = new Date(dateStr[0], dateStr[1] - 1, dateStr[2]);
                    } else {
                        date = new Date(dateStr[2], dateStr[0] - 1, dateStr[1]);
                    }
                    var now = new Date();
                    if (date > now) {
                        return {
                            valid: false
                        };
                    }
                    return {
                        valid: true
                    };
                }
            }
        };

        FormValidation.validators.postalcode = function() {
            return{
                validate: function (input) {
                    var value = input.value;
                    var options = input.options;
                    if (value == '') {
                        return {
                            valid: false
                        };
                    }
                    var usZipRegEx = new RegExp(options.usregexp); //'^\d{5}(?:[-\s]\d{4})?$';
                    var caZipRegEx = new RegExp(options.caregexp); //'^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])\ {0,1}(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$';
                    if (!usZipRegEx.test(value) && !caZipRegEx.test(value)) {
                        return {
                            valid: false
                        };
                    } else {
                        return {
                            valid: true
                        };
                    }

                }
            }
        };
        FormValidation.validators.termsandconditions = function() {
            return {
                validate: function(input) {
                    var $field = $(input.element);
                    return {
                        valid: $field.is(':checked')
                    };
                }
             }
         };
         FormValidation.validators.wtbpostalcode = function() {
             return {
                 validate: function(input) {
                     var value = input.value;
                     if (value == '') {
                         return {
                             valid: false
                         };
                     }
                     var map = {
                         'US': /^\d{5}(?:[-\s]\d{4})?$/, //'(\d{5}([\-]\d{4})?)',
                         'AU': /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/,
                         'CA':
                             /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ])\ {0,1}(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/, //'[A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]',
                         'GB': /[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}/
                     };
                     var country = $('#country-selector').val();
                     var regEx = (country == '') ? /^\d{4}$/ : (map[country] || /^\d{4}$/);

                     if (!regEx.test(value)) {
                         return {
                             valid: false
                         };
                     } else {
                         return {
                             valid: true
                         };
                     }
                 }
             }
        };

        FormValidation.validators.postalOrCityState = function () {
            return {
                validate: function (input) {
                    var $form = $(input.element).closest('form');
                    var postal = $form.find('#zipCode').val();
                    var address = $form.find('#addressInput').val();
                    if ((postal && postal.trim() !== '') || (address && address.trim() !== '')) {

                        var fv = $('#wtbSearch').data('formValidation');
                        if (fv) {
                            fv.resetField('postalCode');
                            fv.resetField('address');
                        }
                        return { valid: true };
                    }
                    return { valid: false };
                },
            };
        };
    }(window.jQuery));

    $('#wtbSearch').formValidation({
        fields: {
            postalCode: {
                validators: {
                    postalOrCityState: {
                        message: $('#requiredPostalMessage').val()
                    }
                }
            },
            address: {
                validators: {
                    postalOrCityState: {
                        message: $('#requiredAddressMessage').val()
                    }
                }
            }
        },
        plugins: {
            declarative: new FormValidation.plugins.Declarative()
        }
    });


    if (typeof SitecoreForm != 'undefined' && SitecoreForm.formValidation().FormId !== null) {

        let $sitecoreForm = $('#' + SitecoreForm.formValidation().FormId);

        if ($sitecoreForm !== null && $sitecoreForm.length > 0) {

            let submitButton = $sitecoreForm.find('[type="submit"]').get(0);

            $sitecoreForm.formValidation({
                fields: {
                    pastdate: {
                        validators: {
                            pastdate: {},
                            postalcode: {}
                        }
                    }
                },
                plugins: {
                    declarative: new FormValidation.plugins.Declarative(),
                    fieldStatus: new FormValidation.plugins.FieldStatus({
                        onStatusChanged: function(areFieldsValid) {
                            areFieldsValid
                                ? submitButton.removeAttribute('disabled')
                                : submitButton.setAttribute('disabled', 'disabled');
                        }
                    })
                }
            });
            //Previously appears to have been used to show a single validator error at a time.
            //This is now accomplished through the sequence plugin.

            //    .on('err.validator.fv', function (e, data) {
            //    data.element
            //        .data('fv.messages')
            //        // Hide all the messages
            //        .find('.help-block[data-fv-for="' + data.field + '"]').hide()
            //        // Show only message associated with current validator
            //        .filter('[data-fv-validator="' + data.validator + '"]').show();
            //});
        }
    }
});